import { isFunction } from "lodash"
import {
  CUSTOM_RANGE,
  FOUR_WEEKS,
  ONE_DAY,
  ONE_WEEK
} from "src/blitz/DateRange/constant"
import {
  IMPERIAL_MEASURE,
  METRIC_MEASURE
} from "src/components/shared/ReportDialog/constants"
import { t } from "src/translations/help"
import {
  PARETO_EQUIPMENT_BY_DATE,
  PARETO_HIGH_TO_LOW,
  PARETO_LOW_TO_HIGH
} from "../../constant"

export const options = {
  systemOfMeasure: [
    {
      title: "Imperial(IP)",
      value: IMPERIAL_MEASURE,
      type: "button"
    },
    {
      title: "Metric(SI)",
      value: METRIC_MEASURE,
      type: "button"
    }
  ],
  timePeriod: [
    {
      title: t("common.oneDay"),
      value: ONE_DAY,
      type: "button"
    },
    {
      title: t("common.oneWeek"),
      value: ONE_WEEK,
      type: "button"
    },
    {
      title: t("common.fourWeeks"),
      value: FOUR_WEEKS,
      type: "button"
    },
    {
      title: t("common.customRange"),
      value: CUSTOM_RANGE,
      type: "button"
    }
  ],
  pareto: [
    {
      title: t("performance.paretoSortOptions.h2L"),
      value: PARETO_HIGH_TO_LOW,
      type: "button"
    },
    {
      title: t("performance.paretoSortOptions.l2H"),
      value: PARETO_LOW_TO_HIGH,
      type: "button"
    },
    {
      title: t("performance.paretoSortOptions.equipByDt"),
      value: PARETO_EQUIPMENT_BY_DATE,
      type: "button"
    }
  ]
}

export const getOptions = (type = "", filterOptions: any = null) => {
  if (type) {
    if (isFunction(filterOptions)) {
      return filterOptions(options?.[type])
    } else {
      return options?.[type]
    }
  } else {
    return []
  }
}

export const CHART_SUB_ID_DIFF = "_"
